import { AlsoThereCard } from '@/components/also-there-card';
import { ComparisonResults } from '@/components/comparison-results';
import { ScenarioSkeleton } from '@/components/scenario-skeleton';
import { Text } from '@/components/text';
import { View } from '@/components/ui/tw-wrappers';
import { SCREEN_MAX_WIDTH } from '@/constants/layout';
import { Country } from '@/types/country';
import { TransferPair } from '@/types/transfer-pair';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

interface ComparisonResultsViewProps {
  data?: TransferPair | null;
  countries: Country[];
  loading: boolean;
  error?: string | null;
  isConfigComplete: boolean;
  inputs: any;
  onSchedulePress: () => void;
}

export function ComparisonResultsView({
  data,
  countries,
  loading,
  error,
  isConfigComplete,
  inputs,
  onSchedulePress,
}: ComparisonResultsViewProps) {
  const { t } = useTranslation();

  return (
    <View style={styles.outerContainer}>
      <View style={styles.innerContainer}>
        <View style={styles.content}>
          {error ? (
            <Text>
              {t('home.scenarios.error', 'Error loading data')}: {error}
            </Text>
          ) : loading || !isConfigComplete ? (
            <View>
              <ScenarioSkeleton />
            </View>
          ) : !data ? (
            <Text>
              {t('home.scenarios.notFound', {
                customer: inputs.customerId,
                vendor: inputs.vendorId,
              })}
            </Text>
          ) : (
            <View className='gap-6'>
              <AlsoThereCard onSchedulePress={onSchedulePress} />
              <ComparisonResults data={data} countries={countries} loading={loading} />
            </View>
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    width: '100%',
    backgroundColor: '#E3E3E3',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 34,
    paddingTop: 40,
  },
  innerContainer: {
    maxWidth: SCREEN_MAX_WIDTH,
    alignSelf: 'center',
    width: '100%',
    gap: 34,
  },
  content: {
    paddingHorizontal: 16,
    gap: 16,
    paddingBottom: 50,
  },
});
